<div class="configuration-container">
  <h2>
    {{ 'mask.configuration.title' | translate }}
  </h2>
  <div id="configuration-form">
    <ng-template appConfigurationMaskHost></ng-template>
  </div>
</div>
